import * as React from 'react';

export const ControlRemove = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" {...props}>
    <path fill="currentColor" d="M8 6.94l5-5L14.06 3l-5 5 5 5L13 14.06l-5-5-5 5L1.94 13l5-5-5-5L3 1.94l5 5z" />
  </svg>
);
